// AU city → suburb map used by the ad-space dropdowns in the assessment form.
export const AU_CITIES = ["Brisbane", "Adelaide", "Perth", "Melbourne", "Sydney"];

export const CITY_SUBURBS = {
    Brisbane: [
        "New Farm", "Fortitude Valley", "South Brisbane", "West End",
        "Toowong", "Chermside", "Kangaroo Point", "Milton", "Newstead",
    ],
    Adelaide: [
        "North Adelaide", "Glenelg", "Norwood", "Prospect", "Unley",
        "Adelaide CBD", "Port Adelaide",
    ],
    Perth: [
        "Northbridge", "Subiaco", "Leederville", "Fremantle", "Cottesloe",
        "Perth CBD", "Joondalup",
    ],
    Melbourne: [
        "South Yarra", "Fitzroy", "St Kilda", "Carlton", "Brunswick",
        "Richmond", "Docklands", "Melbourne CBD", "Southbank",
    ],
    Sydney: [
        "Bondi", "Surry Hills", "Newtown", "Parramatta", "Chatswood",
        "Manly", "Darlinghurst", "Sydney CBD", "Barangaroo",
    ],
};

export const SCREEN_TYPES = [
    "Billboard",
    "Bus Shelter",
    "Urban Panels",
    "Airport",
    "Train Stations",
    "Petrol Stations",
    "Office Buildings",
    "Gyms",
    "Convenience Store",
    "Shopping Centres",
];
